import { useEffect, useState } from 'react'
import { AcceptDenyModal } from '../Modal/AcceptDenyModal'
import { Grid } from '@mui/material'
import CaseloadHistoryCard from '../Cards/CaseloadHistoryCard'
import { type CaseloadHistoryObject } from '../../core/types'
import { sendGet } from '../../hooks/use-fetch'

export function CaseloadHistory (props: { childId: string, visible: boolean, onHide: () => void }): JSX.Element {
  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const { response: rsp, success } = await sendGet(`/CareManagement/ViewCaseloadHistory?childId=${props.childId ?? '0'}`, {
      })
      if (success) {
        setCaseloadHistory(rsp)
      } else {
        setCaseloadHistory(null)
      }
    }
    if (props.visible) {
      void fetchData()
    } else { setCaseloadHistory(null) }
  }, [props.childId, props.visible])
  const handleClose = (): void => {
    props.onHide()
    setCaseloadHistory(null)
  }
  const [caseloadHistory, setCaseloadHistory] = useState<null | CaseloadHistoryObject[]>(null)
  return <AcceptDenyModal maxWidth='sm'
    onClose={handleClose}
    buttonJustification='center'
    open={caseloadHistory != null && props.visible}
    title='Caseload History'
    cancelButtonText='Close'
    dialogContent={<>
      <Grid container gap={2} key={`grid${props.childId}`}>
        {caseloadHistory?.map(h => {
          return <Grid item width={'100%'} key={`historyCard${h.id}`}><CaseloadHistoryCard data={h} /></Grid>
        })}
      </Grid>

    </>}
  />
}
